/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Financial_SettingsInputs */

const en_nav_financial_settings = /** @type {(inputs: Nav_Financial_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Financial Settings`)
};

const es_nav_financial_settings = /** @type {(inputs: Nav_Financial_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuracion financiera`)
};

/**
* | output |
* | --- |
* | "Financial Settings" |
*
* @param {Nav_Financial_SettingsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_financial_settings = /** @type {((inputs?: Nav_Financial_SettingsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Financial_SettingsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_financial_settings(inputs)
	return es_nav_financial_settings(inputs)
});